import React, { useState, useEffect } from 'react';
import Sidebar from '../Sidebar';

import ProcessoSeletivoGestaoVagas from './funil/ProcessoSeletivoGestaoVagas';
import ProcessoSeletivoMonitoramento from './funil/ProcessoSeletivoMonitoramento';
import ProcessoSeletivoTriagem from './funil/ProcessoSeletivoTriagem';
import ProcessoSeletivoEntrevistaAgendamento from './funil/ProcessoSeletivoEntrevistaAgendamento'; 
import ProcessoSeletivoAprovados from './funil/ProcessoSeletivoAprovados';
import ProcessoSeletivoBancoTalentos from './funil/ProcessoSeletivoBancoTalentos';
import ProcessoSeletivoExameAdmissao from './funil/ProcessoSeletivoExameAdmissao';
import ProcessoSeletivoInscricaoInterna from './funil/ProcessoSeletivoInscricaoInterna';

import {
    Users, UserCheck, LayoutDashboard,
    ArrowRight, Briefcase, Clock, PlusSquare, Activity, Archive
} from 'lucide-react';
import HelpCenter from '../HelpCenter';
import ModuloHeader from '../ModuloHeader';
import { CORES } from './psUI';
import { perfilNoModulo } from '../../utils/perfisDerivados';

// 1. DEFINA AS PERMISSÕES (Monitoramento mantido e protegido)
const PERMISSIONS = {
    'gestao-vagas': ['ProcessoSeletivo', 'Diretoria', 'Admin','RH'],
    'monitoramento': ['ProcessoSeletivo', 'RH', 'Diretoria', 'Admin','Gerente'],
    //'inscricao-interna': ['ProcessoSeletivo', 'RH', 'Admin'],
    'inscritos': ['ProcessoSeletivo', 'Diretoria', 'Admin','RH'],
    'agendamento': ['ProcessoSeletivo', 'RH', 'Diretoria', 'Admin','RH'],
    //'exame-admissao': ['ProcessoSeletivo','Medico', 'Diretoria', 'Admin','RH'],
    'aprovados': ['ProcessoSeletivo', 'Diretoria', 'Admin','RH'],
    'banco-talentos': ['ProcessoSeletivo', 'Diretoria', 'Admin','RH']
};

// 2. DEFINA O ARRAY DE MÓDULOS
// Cromo padronizado: cor de acento única do módulo (psUI). Os cards/abas se diferenciam
// pelo ÍCONE + rótulo, não por cor (o "arco-íris" anterior foi removido).
const modulesList = [
    { id: 'gestao-vagas', label: 'Gestão de Vagas', icon: PlusSquare, desc: 'Publique novos anúncios no site.', stat: 'Anúncios' },
    { id: 'monitoramento', label: 'Monitoramento', icon: Activity, desc: 'Visão geral de todos os candidatos.', stat: 'Painel Geral' },
    { id: 'inscritos', label: 'Inscritos', icon: Users, desc: 'Triagem inicial de candidatos.', stat: 'Etapa 1' },
    { id: 'agendamento', label: 'Entrevistas', icon: Clock, desc: 'Gestão e parecer de entrevistas.', stat: 'Etapas 2 e 3' },
    { id: 'aprovados', label: 'Integração/Aprovados', icon: UserCheck, desc: 'Candidato aprovado para integração.', stat: 'Etapa Final' },
    { id: 'banco-talentos', label: 'Banco de Talentos', icon: Archive, desc: 'Reprovados e desistentes do processo.', stat: 'Histórico' }
];

const ProcessoSeletivoPanel = () => {
    const userStr = localStorage.getItem('user');
    const user = userStr ? JSON.parse(userStr) : {};
    const userRole = perfilNoModulo(user?.perfil, 'processoseletivo') || '';

    const [isMobile] = useState(window.innerWidth <= 768);
    const [isCollapsed, setIsCollapsed] = useState(window.innerWidth <= 768);
    const [activeTab, setActiveTab] = useState('dashboard');
    const [isHelpOpen, setIsHelpOpen] = useState(false); // Estado do Manual

    const allowedModules = modulesList.filter(mod => PERMISSIONS[mod.id]?.includes(userRole));

    useEffect(() => {
        const handleResize = () => { if (window.innerWidth <= 768) setIsCollapsed(true); };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (activeTab !== 'dashboard' && !PERMISSIONS[activeTab]?.includes(userRole)) {
            setActiveTab('dashboard');
        }
    }, [activeTab, userRole]);

    const getMarginLeft = () => { return window.innerWidth <= 768 ? '0px' : (isCollapsed ? '80px' : '260px'); };

    // Função que envia o ID correto para o Manual abrir na aba que você está navegando
    const getSecaoAjuda = () => {
        if (activeTab === 'dashboard') return null;
        if (activeTab === 'banco-talentos') return 'historico';
        return activeTab;
    };

    // Métricas de funil migraram para a tela de Monitoramento (centralização — 2026-06-30).
    // Aqui a Visão Geral fica enxuta: banner + cards de navegação.
    const OverviewWidgets = () => {
        return (
            <div>
                {/* BANNER — cor de acento única do módulo (psUI) */}
                <div style={{ background: CORES.gradiente, borderRadius: '16px', padding: '40px', color: '#fff', marginBottom: '32px', position: 'relative', overflow: 'hidden', boxShadow: '0 10px 15px -3px rgba(225, 29, 72, 0.3)' }}>
                    <div style={{ position: 'relative', zIndex: 10 }}>
                        <h2 style={{ fontSize: '32px', fontWeight: '800', marginBottom: '12px', marginTop: 0, color: '#fff' }}>Portal de Recrutamento</h2>
                        <p style={{ color: '#ffe4e6', fontSize: '18px', maxWidth: '650px', margin: 0, lineHeight: '1.6' }}>Monitoramento e Funil de Conversão do Processo Seletivo.</p>
                    </div>
                    <div style={{ position: 'absolute', right: '-30px', top: '-40px', opacity: 0.15 }}><Briefcase size={250} color="#ffffff" /></div>
                </div>

                {/* As métricas de funil agora vivem na aba Monitoramento (centralização). */}
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '24px' }}>
                    {allowedModules.map((mod) => (
                        <div key={mod.id} onClick={() => setActiveTab(mod.id)} style={{ backgroundColor: '#fff', borderRadius: '16px', padding: '24px', border: '1px solid #e2e8f0', display: 'flex', flexDirection: 'column', height: '100%', cursor: 'pointer', position: 'relative', overflow: 'hidden', transition: 'all 0.2s', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)' }}>
                            <div style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: '4px', backgroundColor: CORES.primaria }}></div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '20px', width: '100%' }}>
                                <div><p style={{ fontSize: '12px', fontWeight: '800', textTransform: 'uppercase', color: CORES.primaria, marginBottom: '8px', margin: 0 }}>{mod.stat}</p><h3 style={{ fontSize: '22px', fontWeight: '800', color: '#0f172a', margin: 0 }}>{mod.label}</h3></div>
                                <div style={{ padding: '12px', borderRadius: '12px', backgroundColor: CORES.primariaBg, color: CORES.primaria }}><mod.icon size={26} /></div>
                            </div>
                            <div style={{ marginTop: 'auto' }}>
                                <p style={{ fontSize: '14px', color: '#64748b', fontWeight: '500', lineHeight: '1.5', margin: '0 0 16px 0' }}>{mod.desc}</p>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', fontWeight: '700', color: CORES.primaria }}><span>Acessar</span> <ArrowRight size={16} /></div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    const renderContent = () => {
        if (activeTab === 'dashboard') return <OverviewWidgets />;
        switch(activeTab) {
            case 'gestao-vagas': return <div style={contentBoxStyle}><ProcessoSeletivoGestaoVagas /></div>;
            case 'monitoramento': return <div style={contentBoxStyle}><ProcessoSeletivoMonitoramento irParaAba={setActiveTab} /></div>;
            case 'inscritos': return <div style={contentBoxStyle}><ProcessoSeletivoTriagem /></div>;
            case 'inscricao-interna': return <div style={contentBoxStyle}><ProcessoSeletivoInscricaoInterna /></div>;
            case 'agendamento': return <div style={contentBoxStyle}><ProcessoSeletivoEntrevistaAgendamento /></div>; 
            case 'aprovados': return <div style={contentBoxStyle}><ProcessoSeletivoAprovados /></div>;
            case 'exame-admissao': return <div style={contentBoxStyle}><ProcessoSeletivoExameAdmissao /></div>;
            case 'banco-talentos': return <div style={contentBoxStyle}><ProcessoSeletivoBancoTalentos /></div>;
            default: return null;
        }
    };

    const contentBoxStyle = { backgroundColor: '#fff', borderRadius: '16px', border: '1px solid #e2e8f0', padding: '24px', minHeight: '500px' };

    return (
        <div style={{ display: 'flex', minHeight: '100vh', backgroundColor: '#f8fafc' }}>
            <Sidebar isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} mostrarBotaoMobile={false} />
            <div style={{ flex: 1, marginLeft: getMarginLeft(), transition: 'margin-left 0.3s ease' }}>
                
                {/* CABEÇALHO — padrão dos módulos, na cor de acento do Processo Seletivo (vinho) */}
                <ModuloHeader
                    eyebrow="Módulo"
                    titulo="Processo Seletivo"
                    cor={CORES.primaria}
                    onAbrirManual={() => setIsHelpOpen(true)}
                    onAbrirMenu={() => setIsCollapsed(false)}
                    isMobile={isMobile}
                />
                
                <div style={{ padding: '40px', maxWidth: '1600px', margin: '0 auto', width: '100%', boxSizing: 'border-box' }}>
                    
                    {/* BARRA DE NAVEGAÇÃO CORRIGIDA (FLEX-WRAP ADICIONADO E BOTÃO MODERNO) */}
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginBottom: '32px', backgroundColor: '#fff', padding: '8px', borderRadius: '12px', border: '1px solid #e2e8f0', width: '100%' }}>
                        
                        {/* Botão de Visão Geral com visual mais moderno */}
                        <button onClick={() => setActiveTab('dashboard')} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 20px', borderRadius: '8px', border: 'none', fontWeight: '600', cursor: 'pointer', transition: 'all 0.2s', background: activeTab === 'dashboard' ? CORES.gradiente : 'transparent', color: activeTab === 'dashboard' ? '#fff' : '#64748b', boxShadow: activeTab === 'dashboard' ? '0 4px 6px rgba(225, 29, 72, 0.3)' : 'none', whiteSpace: 'nowrap' }}>
                            <LayoutDashboard size={18} /> Visão Geral
                        </button>

                        <div style={{ minWidth: '1px', backgroundColor: '#e2e8f0', margin: '0 5px' }}></div>

                        {allowedModules.map((mod) => (
                            <button key={mod.id} onClick={() => setActiveTab(mod.id)} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 20px', borderRadius: '8px', fontWeight: '600', cursor: 'pointer', transition: 'all 0.2s', border: activeTab === mod.id ? `2px solid ${CORES.primaria}` : '2px solid transparent', backgroundColor: activeTab === mod.id ? CORES.primariaBg : 'transparent', color: activeTab === mod.id ? CORES.primaria : '#64748b', whiteSpace: 'nowrap' }}>
                                <mod.icon size={18} /> {mod.label}
                            </button>
                        ))}
                    </div>
                    
                    {renderContent()}
                </div>
            </div>

            {/* Renderiza o Manual por cima da tela */}
            <HelpCenter 
                isOpen={isHelpOpen} 
                onClose={() => setIsHelpOpen(false)} 
                secaoInicial={getSecaoAjuda()}
                modulo="processo-seletivo"
            />
        </div>
    );
};

export default ProcessoSeletivoPanel;